"use client";

// import { init as initApm } from "@elastic/apm-rum";
import { profileAPI } from "@/lib/api/api";
import { getCookie } from "@/utils";
import { getSiteProps } from "@/utils/siteProps";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { init as initApm } from "@elastic/apm-rum";
import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer?: Object[];
    [key: string]: any;
  }
}

const appendScript = ({ path }: { path: string }) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = path;
  script.defer = true;
  document.body.appendChild(script);
};

const enableRumMonitoring = process.env.ENABLE_RUM_MONITORING === "true";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const apm = initApm({
  serviceName: process.env.ELASTIC_APM_SERVICE_NAME,
  serverUrl: process.env.ELASTIC_APM_SERVER_URL,
  serviceVersion: process.env.ELASTIC_APM_SERVICE_VERSION,
  active: enableRumMonitoring,
});

const ExecuteScripts = ({
  siteProps,
  isMobile,
}: {
  siteProps?: sitePropsType;
  isMobile: boolean;
}) => {
  const mediaUrl = siteProps?.mediaUrl || "media.foundit.in";

  const scriptPath = [
    `//${mediaUrl}/public/v2/seeker/public/script/clevertapIntegration.js`,
    "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
    `//${mediaUrl}/public/v2/seeker/public/script/abTestingIntegration.js`,
    // `//${mediaUrl}/public/core/static/gaTrack.js`,
    // `//${mediaUrl}/public/core/static/userTrackSystem.js`,
  ];

  const executeGtmScript = (siteProps: SiteDetailsType | null) => {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    (function (w: any, d: any, s: any, l: any, i: any) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== "dataLayer" ? "&l=" + l : "";
      j.defer = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", siteProps?.gtm_id);
  };

  const loadHandler = () => {
    scriptPath.forEach((path) => {
      appendScript({ path });
    });

    const siteProps = getSiteProps(window.location.host);

    if (siteProps?.domain !== "monster.com.vn") {
      // Disabling the GTM script for Vietnam channel - https://monsterconfluence.atlassian.net/browse/TECH-1576
      executeGtmScript(siteProps);
    }

    document.removeEventListener("scroll", loadHandler);
    document.body.removeEventListener("click", loadHandler, true);
  };

  const fetchUserData = async () => {
    try {
      const data = await profileAPI("personal_details");
      const typedData = data as {
        personalDetailSection?: {
          personalDetails?: { primaryEmail?: { email: string } };
        };
      };
      const userId =
        typedData?.personalDetailSection?.personalDetails?.primaryEmail?.email;
      if (typeof window !== "undefined" && userId) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "userData", userId });
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    const isLoggedIn =
      typeof window !== "undefined" ? !!getCookie("MSSOCLIENT") : false;
    if (isLoggedIn) fetchUserData();
  }, []);

  useEffect(() => {
    window._siteProps_ = siteProps;

    const hostName = window.location.host;
    const siteMap = getSiteProps(hostName)?.site_map;
    const preferenceCookie = getCookie("preferences");
    const pageName = window.location.pathname;
    const disallowedPages = [
      "/seeker/registration",
      "/seeker-profile/registration",
      "/seeker/single-page-registration",
      "/seeker-profile/single-page-registration",
    ];
    const urlParams = new URLSearchParams(window.location.search);
    const isApp = urlParams.has("app") && urlParams.get("app") === "true";

    const isLocal = hostName.includes("localhost");

    if (
      siteMap === "rexmonster" &&
      !preferenceCookie &&
      !isApp &&
      !isLocal &&
      !disallowedPages.includes(pageName)
    ) {
      const scriptUrl =
        "https://media.foundit.in/dpdpa-banners/dpdpa-script.js";
      appendScript({ path: scriptUrl });
    }

    loadHandler();

    trackClevertapEvents.eventPageView();

    return () => {
      document.removeEventListener("scroll", loadHandler);
      document.body.removeEventListener("click", loadHandler, true);
    };
  }, []);
  return null;
};

export default ExecuteScripts;
